const getENV = (key: string): string => {
    return process.env[`REACT_APP_${key}`] ?? '';
};

const config = {
    NODE_ENV: getENV('NODE_ENV'),
    CURRENT_URL: getENV('CURRENT_URL'),
    API_URL: getENV('API_URL'),
};

if(config.NODE_ENV !== 'prod') {
    console.log(`Config Loading...`, config);
}

export default config;